// Application Constants
export const TIMING = {
  SESSION_WARNING: 25 * 60 * 1000, // 25 minutes in milliseconds
  SESSION_TIMEOUT: 30 * 60 * 1000, // 30 minutes in milliseconds
  SESSION_CHECK: 60 * 1000, // 1 minute
  SECURITY_CHECK_INTERVAL: 60 * 1000, // 1 minute
  RATE_LIMIT_WINDOW: 15 * 60 * 1000, // 15 minutes
  CACHE_DURATION: 5 * 60 * 1000, // 5 minutes
  RETRY_DELAY: 1000, // 1 second
  DEBOUNCE_DELAY: 300, // 300ms
  ANIMATION_DURATION: 200, // 200ms
  ANIMATION_SLOW: 400, // 400ms
  SHORT_DELAY: 150, // 150ms
  TOAST_DURATION: 4000, // 4 seconds
  TOAST_AUTO_DISMISS: 3000, // 3 seconds
  SUCCESS_DELAY: 1500, // 1.5 seconds
  AUTO_SAVE_INTERVAL: 30 * 1000, // 30 seconds
  USER_FEEDBACK_DELAY: 500, // 500ms
  BALANCE_COLUMNS_DELAY: 100, // 100ms
  RESIZE_DEBOUNCE: 250, // 250ms
  ACTIVITY_CHECK: 30 * 1000, // 30 seconds
  COPY_FEEDBACK: 2000, // 2 seconds
  HEALTH_CHECK_DELAY: 5000, // 5 seconds
  PERFORMANCE_MONITOR: 10 * 1000, // 10 seconds
  ADMIN_WIDGET_REFRESH: 30 * 1000, // 30 seconds
};

export const LAYOUT_THRESHOLDS = {
  MIN_COLUMN_WIDTH: 200,
  MAX_COLUMNS: 4,
  MIN_COLUMNS: 1,
  BREAKPOINT_SM: 640,
  BREAKPOINT_MD: 768,
  BREAKPOINT_LG: 1024,
  CONTENT_PADDING: 16,
  COLUMN_GAP: 20,
  COLUMN_HEIGHT_DIFFERENCE: 50,
  BALANCE_STABLE_COUNT: 3,
};

export const CORE_WEB_VITALS = {
  LCP_GOOD: 2500, // Largest Contentful Paint - Good (ms)
  LCP_POOR: 4000, // Largest Contentful Paint - Poor (ms)
  LCP: {
    GOOD: 2500,
    POOR: 4000,
  },
  FID_GOOD: 100, // First Input Delay - Good (ms)
  FID_POOR: 300, // First Input Delay - Poor (ms)
  FID: {
    GOOD: 100,
    POOR: 300,
  },
  CLS_GOOD: 0.1, // Cumulative Layout Shift - Good
  CLS_POOR: 0.25, // Cumulative Layout Shift - Poor
  CLS: {
    GOOD: 0.1,
    POOR: 0.25,
  },
  TTFB_GOOD: 800, // Time to First Byte - Good (ms)
  TTFB_POOR: 1800, // Time to First Byte - Poor (ms)
  LOAD_TIME: {
    GOOD: 3000,
    POOR: 6000,
  },
};

export const PERFORMANCE_SCORE = {
  EXCELLENT: 90,
  EXCELLENT_MIN: 90,
  GOOD: 75,
  GOOD_MIN: 75,
  FAIR: 50,
  POOR: 25,
  MAX_SCORE: 100,
  MIN_SCORE: 0,
  BASE_SCORE: 100,
};

export const PERFORMANCE_PENALTIES = {
  SLOW_LCP: -20,
  SLOW_FID: -15,
  HIGH_CLS: -25,
  SLOW_TTFB: -10,
  LARGE_BUNDLE: -15,
  MANY_REQUESTS: -10,
  UNOPTIMIZED_IMAGES: -20,
  LCP_POOR: -20,
  LCP_FAIR: -10,
  FID_POOR: -15,
  FID_FAIR: -8,
  CLS_POOR: -25,
  CLS_FAIR: -12,
  MEMORY_HIGH: -15,
  MEMORY_MEDIUM: -8,
  LOAD_TIME_POOR: -20,
  LOAD_TIME_FAIR: -10,
  LOW_BATTERY: -5,
};

export const MEMORY_THRESHOLDS = {
  LOW: 512 * 1024 * 1024, // 512MB
  MEDIUM: 1024 * 1024 * 1024, // 1GB
  HIGH: 2048 * 1024 * 1024, // 2GB
  CRITICAL: 4096 * 1024 * 1024, // 4GB
  WARNING: 1536 * 1024 * 1024, // 1.5GB
};

export const BATTERY_THRESHOLDS = {
  CRITICAL: 10, // 10%
  LOW: 20, // 20%
  MEDIUM: 50, // 50%
  HIGH: 80, // 80%
};

export const API_ENDPOINTS = {
  PRODUCTS: '/api/products',
  COLLECTIONS: '/api/collections',
  FAVORITES: '/api/favorites',
  CART: '/api/cart',
  ORDERS: '/api/orders',
  AUTH: '/api/auth',
  ANALYTICS: '/api/analytics',
};

export const STORAGE_KEYS = {
  THEME: 'theme-preference',
  CART: 'shopping-cart',
  FAVORITES: 'user-favorites',
  RECENTLY_VIEWED: 'recently-viewed',
  SEARCH_HISTORY: 'search-history',
  USER_PREFERENCES: 'user-preferences',
};

export const BREAKPOINTS = {
  SM: 640,
  MD: 768,
  LG: 1024,
  XL: 1280,
  '2XL': 1536,
};

export const PRODUCT_LIMITS = {
  PER_PAGE: 24,
  FEATURED: 8,
  RELATED: 4,
  RECENTLY_VIEWED: 10,
  SEARCH_RESULTS: 50,
};